const formatNumber = (number: number | any): string | any => {
	return number
		? (+number).toLocaleString("sr-RS", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
		  })
		: 0
}

export default formatNumber
